import React, { useState } from 'react';

import HeatmapDisplay from 'components/Meteorology/Fields/HeatmapDisplay';
import { cssVar } from 'constants/theme';

import FullscreenHeatmap from './FullscreenHeatmap';

import './index.scss';

export interface HeatmapCardProps {
  base64: string;
  fetching: boolean;
}

export default function HeatmapCard({ base64, fetching }: HeatmapCardProps) {
  const [fullscreenOpen, setFullscreenOpen] = useState(false);
  const hasImage = !fetching && !!base64;

  return (
    <div className="observed-data-mobile-heatmap">
      <div className="observed-data-mobile-heatmap-card">
        <div className="observed-data-mobile-heatmap-card-header">
          <span className="observed-data-mobile-heatmap-card-title">
            Realizado · magnitude e anomalia
          </span>
          {hasImage && (
            <button
              type="button"
              aria-label="Tela cheia"
              className="observed-data-mobile-heatmap-card-action"
              onClick={() => setFullscreenOpen(true)}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke={cssVar('text-strong')}
                strokeWidth={1.8}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M8 21H5a2 2 0 0 1-2-2v-3M16 21h3a2 2 0 0 0 2-2v-3" />
              </svg>
            </button>
          )}
        </div>
        <div className="observed-data-mobile-heatmap-card-body">
          <HeatmapDisplay base64={base64} fetching={fetching} imageMaxWidth="100%" />
        </div>
      </div>
      <FullscreenHeatmap
        open={fullscreenOpen}
        dismiss={() => setFullscreenOpen(false)}
        base64={base64}
      />
    </div>
  );
}
